import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlyModule } from "@ngx-formly/core";
import { MaterialModule } from "../../../core/shared/material.module";
import { DynamicFormComponent } from "../../common/dynamic-form/dynamic-form.component";

@Component({
  selector: "app-agent-create-modal",
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    FormlyBootstrapModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormComponent,
    MaterialModule,
  ],
  templateUrl: "./agent-create-modal.component.html",
  styleUrl: "./agent-create-modal.component.scss",
})
export class AgentCreateModalComponent {
  @Input()
  configs: any = {};

  @Input()
  fields: any = [];

  model: any = {};

  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});
  isActive: boolean = false;

  ngOnInit() {
    if (this.configs.isEdit) {
      this.dynamicForm.value = this.configs.model;

      const dateFields = ["startDate", "releaseDate", "expiration"];

      this.fields = this.fields.map((field: any) => ({
        ...field,
        value:
          dateFields.includes(field.key) && this.configs.model[field.key]
            ? new Date(this.configs.model[field.key])
            : this.configs.model[field.key] || "",
      }));
    }
  }

  /**
   * Handles the submission of the dynamic form.
   * Closes the modal and passes the current form controls as the result.
   */
  submit() {
    this.activeModal.close({
      value: this.dynamicForm.value,
      fields: this.fields,
    });
  }
}
